import { render, staticRenderFns } from "./ProveedorTab.vue?vue&type=template&id=2a15e8b8&"
import script from "./ProveedorTab.vue?vue&type=script&lang=js&"
export * from "./ProveedorTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports